export default function Events() {
    return (
        <div data-testid="events-page" className="pt-28 md:pt-36 pb-24">
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
                {/* Header */}
                <div className="grid grid-cols-12 gap-y-6 md:gap-x-10 items-end mb-16 md:mb-24 rise">
                    <div className="col-span-12 md:col-span-8">
                        <p className="font-mono-acc text-[11px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                            § Events / Bulletin
                        </p>
                        <h1 className="mt-6 font-serif-display text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-[-0.03em]">
                            One night.
                            <br />
                            <span className="italic">One record.</span>
                        </h1>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:pb-4">
                        <p className="font-body text-base md:text-lg text-[var(--ink)]/80 leading-relaxed">
                            We don't run a season. We run rituals. Bring a
                            friend, bring patience, bring something to throw on
                            the wall.
                        </p>
                    </div>
                </div>

                {/* The Ticket */}
                <article
                    data-testid="event-ticket"
                    className="relative mx-auto max-w-5xl rise rise-d1"
                >
                    <div className="bg-[var(--bg-paper)] border border-[var(--ink)] shadow-[6px_6px_0_0_var(--ink)] relative">
                        {/* Top strip */}
                        <div className="flex items-center justify-between border-b border-dashed border-[var(--ink)] px-6 md:px-10 py-4">
                            <span className="font-mono-acc text-[10px] md:text-xs tracking-[0.32em] uppercase">
                                K-Team Presents · No. 001
                            </span>
                            <span className="font-mono-acc text-[10px] md:text-xs tracking-[0.32em] uppercase text-[var(--sienna)]">
                                Admit One ✦
                            </span>
                        </div>

                        {/* Body */}
                        <div className="flex flex-col md:flex-row">
                            {/* Date column */}
                            <div className="md:w-[28%] border-b md:border-b-0 md:border-r border-dashed border-[var(--ink)] p-8 md:p-10 text-center bg-[var(--bg-surface)]">
                                <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)]">
                                    Sunday
                                </p>
                                <p className="font-serif-display text-7xl md:text-8xl leading-none mt-3 text-[var(--ink)]">
                                    21
                                </p>
                                <p className="font-mono-acc text-sm tracking-[0.32em] uppercase mt-3">
                                    June
                                </p>
                                <div className="mt-6 h-px w-12 bg-[var(--ink)]/40 mx-auto" />
                            </div>

                            {/* Main */}
                            <div className="md:w-[58%] p-8 md:p-12">
                                <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                                    Album Release Party
                                </p>
                                <h2 className="font-serif-display text-5xl md:text-7xl leading-[0.92] mt-3 tracking-[-0.02em]">
                                    Record Release{" "}
                                    <span className="italic">Flytrap</span>
                                </h2>

                                <div className="mt-8 space-y-3 font-body text-base md:text-lg text-[var(--ink)]/85">
                                    <p>
                                        <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] block mb-1">
                                            Performances
                                        </span>
                                        Flytrap
                                    </p>
                                    <p>
                                        <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] block mb-1">
                                            Record
                                        </span>
                                        <span className="italic">
                                            Weapon of Mass Creation
                                        </span>
                                    </p>
                                    <p>
                                        <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] block mb-1">
                                            Venue
                                        </span>
                                        Sweet Loretta Bar — 715 11th Ave SW,
                                        Calgary, AB
                                    </p>
                                </div>

                                <div className="mt-10 flex flex-wrap items-center gap-6">
                                    <button
                                        type="button"
                                        data-testid="event-rsvp-button"
                                        className="btn-edit"
                                        style={{
                                            background: "var(--ink)",
                                            color: "var(--bg-base)",
                                        }}
                                    >
                                        Save the date
                                    </button>
                                </div>
                            </div>

                            {/* Stub */}
                            <div className="md:w-[14%] border-t md:border-t-0 md:border-l border-dashed border-[var(--ink)] p-6 flex md:flex-col items-center justify-between bg-[var(--bg-surface)]">
                                <div className="md:vertical-text font-mono-acc text-[10px] tracking-[0.5em] uppercase text-[var(--ink)]/70">
                                    Admit · 21·06·26 · 001
                                </div>
                                <div className="md:mt-4">
                                    <div className="flex gap-[2px] items-end h-10">
                                        {[3, 6, 2, 8, 4, 5, 3, 7, 2, 8, 4, 6].map(
                                            (h, i) => (
                                                <span
                                                    key={i}
                                                    className="block w-[2px] bg-[var(--ink)]"
                                                    style={{
                                                        height: `${h * 12}%`,
                                                    }}
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>

                {/* Notes */}
                <div className="mt-24 md:mt-32 grid grid-cols-12 gap-y-10 md:gap-x-10">
                    <div className="col-span-12 md:col-span-12 rise rise-d4">
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                            After
                        </p>
                        <p className="mt-4 font-serif-display text-3xl leading-tight">
                            DJ&rsquo;s. Dancefloor.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
